<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
    <el-tab-pane name="xjrwgl">
      <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 警示提醒书管理 </span>
      <normalNav :parent="self">
        <button class="GreenSmBtn download" @click="editDialogVisible=true">下发</button>
      </normalNav>
      <div class="searchForm1">
        <searchForm :items="items" :formPlus="form_xjrwgl" ref="searchForm_xjrwgl">
        </searchForm>
      </div>
      <div class="tableWrapper">
        <easyTable apiUrl="operation/alertsApi/findAlertsPageList" :parent="self" :config="config" :other="other" ref="table_xjrwgl">
          <template slot="last">
            <el-table-column label="详情" width="200" align="center">
              <template slot-scope="scope">
                <el-link :href="scope.row.url" icon="iconfont iconcheck" type="text" size="small" download="附件" target="_blank">附件下载</el-link>
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>

      <el-dialog class="editDialog" title="下发" :visible.sync="editDialogVisible" :close-on-click-modal="false">
        <section class="list">
          <el-form ref="form1" :model="form1" :rules="rule">

            <el-form-item label="类型" prop="dicTypeDataId">
              <el-select class="darkSelect" :popper-append-to-body="false" v-model="form1.dicTypeDataId" filterable default-first-option placeholder="请选择" style="width:auto;">
                <el-option v-for="item in tzs" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="负责部门" prop="takeDeptId">
              <nextCompany @changeCompany="changeCompany"></nextCompany>
            </el-form-item>

            <el-form-item label="负责人员" prop="takeEmpId" v-show="form1.takeDeptId">
              <el-select class="darkSelect" v-model="form1.takeEmpId" filterable default-first-option placeholder="" style="width:auto;" v-loading="preLoading" :popper-append-to-body="false">
                <el-option v-for="item in takeEmpId" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="附件上传" prop="url">
              <el-upload-secondary class="YnormalCard" v-model="form1.url" :limit="1" accepts="docx,pdf,png,jpg">
                <i class="el-icon-plus"></i>
              </el-upload-secondary>
              <div class="el-form-item__error" v-show="!form1.url||form1.url.length==0" slot="error">
                请上传附件
              </div>
            </el-form-item>

          </el-form>
        </section>

        <div slot="footer" class="dialog-footer">
          <el-button class="confirmButton" type="primary" @click="xiafa">提交</el-button>
          <el-button class="cancelButton" type="primary" @click="editDialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  obj2urlsp,
  descriptor
} from "utils";
export default {
  data() {
    return {
      tabName: 'xjrwgl',
      tzs: [],
      form_xjrwgl: {},
      editLoading: true,
      editDialogVisible: false,
      data: {},
      other: {},
      form1: {},
      preLoading: true,
      takeEmpId: []
    };
  },
  computed: {
    items() {
      const that = this;
      return [{
          type: "start",
          prop: "startTime",
          label: "开始时间"
        },
        {
          type: "end",
          prop: "endTime",
          label: "结束时间"
        },
        {
          type: "select",
          prop: "altersType",
          label: "类型",
          option: {
            option: that.tzs,
            label: 'name',
            value: 'id'
          }
        }
      ]
    },
    self() {
      return this;
    },
    config() {
      return [{
        prop: 'sendTime',
        label: '下发时间'
      }, {
        prop: 'typeName',
        label: '通知书类型'
      }, {
        prop: 'sendDeptName',
        label: '下发部门'
      }, {
        prop: 'sendEmpName',
        label: '下发人员'
      }, {
        prop: 'takeDeptName',
        label: '负责部门'
      }, {
        prop: 'takeEmpName',
        label: '负责人员'
      }];
    },
    download() {
      let data = this.formData;
      this.$axios
        .post(
          process.env.API_HOST +
          "/operation/alarmCountApi/export/exportAlarmCount?"  +
            "companyId=" +
            localStorage.getItem("companyId") +
            "&userId=" +
            this.$store.state.user.id +
            "&systemId=" +
            data.systemId +
            "&areaId=" +
            data.areaId +
            "&typeId=" +
            data.typeId +
            "&startTime=" +
            data.startTime +
            "&endTime=" +
            data.endTime,
        )
        .then(res => {
          // //console.log(res);
        });
    },
    rule() {
      let that = this;
      return {
        takeDeptId: descriptor(new Map([
          [true, "请选择负责部门"]
        ]), "blur"),
        takeEmpId: descriptor(new Map([
          [true, "请选择负责人员"]
        ]), "blur"),
        dicTypeDataId: descriptor(new Map([
          [true, "请选择类型"]
        ]), "blur"),
        url: descriptor(new Map([
          [true, "请上传文件"]
        ]), "blur")
      }
    }
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.form_xjrwgl = {};
    },
    search_xjrwgl(fn) {
      fn();
    },
    changeCompany(v) {
      this.$set(this.form1, 'takeDeptId', v);
      this.$set(this.form1, 'takeEmpId', '');
      this.preLoading = true;
      this.$axiosget(`operation/empApi/findEmpAllByDepId/${this.form1.takeDeptId}`).then(res => {
        this.preLoading = false;
        if (!res.data.data) return;
        this.takeEmpId = res.data.data;
      })
    },
    xiafa() {
      this.$refs.form1.validate(valid => {
        if (valid) {
          this.editLoading = true;
          let url = process.env.fileUrl + '/' + this.form1.url[0].response.data[0];
          this.$axiospost('operation/alertsApi/addAlerts', {
            ...this.form1,
            url
          }).then(res => {
            this.$message({
              showClose: true,
              message: '下发成功',
              type: 'success'
            });
            this.editLoading = false;
            this.editDialogVisible = false;
            this.$refs['table_xjrwgl'].getData();
          })
        }
      })
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    nextCompany: () => import("public/nextCompany")
  },
  mounted() {
    this.$axiosget('operation/dictionaryData/queryByKey', {
      params: {
        key: "alerts"
      }
    }).then(res => {
      //console.log(res.data.data, 888888888888888888);
      this.tzs = res.data.data;
    })
    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });

    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom:1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/dcdb/jstxsgl/index.vue